import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, onMounted, watch, unref } from 'vue';
import { ElButton } from 'element-plus'
import { GbTables } from '@/components/GbTables'
import { BillAuditDialog } from '@/views/bills/components/Index'
import { useGbTable } from '@/hooks/useGbTable'
import { BillTaskApi } from '@/apis/tasks/task.api'
import { TableColumn } from '@/components/GbTables/GbTablesTypes'
import { WorkItemSearch, WorkItem } from '@/apis/tasks/task.type'
import { BillEditor }  from '@/views/workflow/pay/components/Index'
import moment from 'moment'
import { useDictionary } from '@/store/dictionary.store';
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  emits: ['uploadTotal'],
  setup(__props, { emit: $emits }) {

const { t } = useLocales();


const billAuditRef = ref<ComponentRef<typeof BillAuditDialog>>()
const billEditorRef = ref<ComponentRef<typeof BillEditor>>()

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<WorkItem>({
    getListApi: BillTaskApi,
    response: { data: 'data', total: 'total' },
})

const { setSearchParams } = methods;
const { getName } = useDictionary();

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'ct_name', label: t('contract.name', '合同名称'), columnWidth: '160' },
    { field: 'plan_name', label: t('bill.planName', '款项名称'), columnWidth: '200' },
    { field: 'plan_condition', label: t('bill.planCondition', '款项条件') },
    { field: 'kingdee_type', label: t('bill.kingdeeType', '金蝶单据类型'), align: 'center', columnWidth: '120'},
    { field: 'amount', label: t('bill.applyAmount', '申请金额'), columnWidth: '120', align: 'right' },
    { field: 'pay_date', label: t('bill.expectedDate', '预计付/收款日期'), columnWidth: '120', align: 'center' },
    // { field: 'pay_status', label: '付款状态', columnWidth: '120', align: 'center' },
    { field: 'pay_status_name', label: t('bill.payStatus', '付款状态'), columnWidth: '120', align: 'center' },
    { field: 'node_name', label: t('workflow.node', '流程节点'), columnWidth: '80', fixed: 'right', align: 'center' },
    { field: 'sub_emp_name', label: t('bill.initiator', '发起人'), columnWidth: '80', fixed: 'right', align: 'center' },
    { field: 'sub_date', label: t('bill.initiateDate', '发起日期'), columnWidth: '120', fixed: 'right', align: 'center' },
    { field: 'action', width: '180px', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
])

/* 查询数据 */
const search = reactive<any>({
    Work_type: 1,
    current: 1,
    page_size: 10,
})

/* 私有的方法 */
const actions = {
    /* 数据预览 */
    preview: (row: any) => {
        unref(billAuditRef)?.showDialog(row.bill_id, true)
    },

    /* 审核 */
    audit: (row: any) => {
        unref(billAuditRef)?.showDialog(row.bill_id, false)
    },
    reSet: () => {
        search.page_size = 10
        search.current = 1
        search.Work_type = 1
        setSearchParams(search)
    },
    edit: (row: any) => {
        unref(billEditorRef)?.showDialog(row.plan_id, row.bill_id)
    }
}

watch(
    () => tableObject.total,
    (total: number) => { $emits('uploadTotal', total) },
    { immediate: true, deep: true }
)

onMounted(() => {
    setSearchParams(search)
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(search),
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contract.no', '合同编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(search).ct_no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).ct_no) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contract.name', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(search).ct_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(search).ct_name) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('workflow.taskType', '任务类型')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(search).Work_type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(search).Work_type) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('title.myWork', '待办')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('workflow.completed', '已办')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSet
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      icon: "Search",
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amount.toLocaleString('zh')), 1)
          ]),
          pay_date: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.pay_date ? _unref(moment)(row.pay_date).format('YYYY-MM-DD') : '--'), 1)
          ]),
          sub_date: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.sub_date).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          kingdee_type: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(getName)('kingdee_type',row.kingdee_type) || _unref(t)('bill.paymentApply', '付款申请')), 1)
          ]),
          action: _withCtx(({ row }) => [
            (_unref(search).Work_type == 1 && row.pay_status == 5)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 0,
                  type: "success",
                  link: "",
                  onClick: ($event: any) => (actions.edit(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttons.modify', '修改')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (_unref(search).Work_type == 1 && row.pay_status != 5)
              ? (_openBlock(), _createBlock(_unref(ElButton), {
                  key: 1,
                  type: "success",
                  link: "",
                  onClick: ($event: any) => (actions.audit(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('buttons.audit', '审批')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(ElButton), {
              type: "primary",
              link: "",
              onClick: ($event: any) => (actions.preview(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.preview', '详细')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(_unref(BillAuditDialog), {
      ref_key: "billAuditRef",
      ref: billAuditRef,
      onSuccess: _cache[9] || (_cache[9] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
    }, null, 512),
    _createVNode(_unref(BillEditor), {
      ref_key: "billEditorRef",
      ref: billEditorRef,
      onSuccess: _cache[10] || (_cache[10] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
    }, null, 512)
  ], 64))
}
}

})